import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import {
  type ToastNotification,
  ToastNotificationsService,
} from '@reconcept-platform/shared/ui/core/toast-notifications';
import { ToastNotificationComponent } from './toast-notification/toast-notification.component';

@Component({
  selector: 'rcp-toast-notifications',
  styleUrls: ['./toast-notifications.component.scss'],
  template: `
    @for (notification of notifications; track notification) {
      <rcp-toast-notification [notification]="notification" (close)="close(notification)"></rcp-toast-notification>
    }
  `,
  imports: [ToastNotificationComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ToastNotificationsComponent implements OnInit {
  private toast = inject(ToastNotificationsService);

  notifications: ToastNotification[];

  ngOnInit() {
    this.toast.notifications$.subscribe((notifications) => (this.notifications = notifications));
  }

  close(notification: ToastNotification) {
    this.toast.close(notification);
  }
}
